export const modifyFavouriteProducts = (favouriteProduct, products) => {
  let selectedProduct = products.find(
    product => product.product_id === favouriteProduct.product_id
  );

  if (selectedProduct) {
    let selectedVariant = selectedProduct.prices.find(
      price => price.variant_id === favouriteProduct.variant_id
    );
    if (selectedVariant) {
      return {
        ...favouriteProduct,
        price: selectedVariant.price,
        prices: selectedProduct.prices,
      };
    } else return favouriteProduct;
  } else return favouriteProduct;
};
